function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#7D7C97",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M182.424 146.333H40.134c-6.676 0-12.206-4.986-12.867-11.596l-9.334-93.073a3.328 3.328 0 0 1 .856-2.584 3.375 3.375 0 0 1 2.502-1.107h179.99c.95 0 1.86.403 2.502 1.107.64.698.95 1.644.856 2.584l-9.327 93.073c-.675 6.61-6.212 11.596-12.888 11.596zM25.007 44.691l8.964 89.382a6.153 6.153 0 0 0 6.157 5.55h142.296c3.196 0 5.847-2.383 6.164-5.55l8.963-89.382H25.007z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.925 44.69H11.634C5.22 44.69 0 39.497 0 33.115V11.653C0 5.27 5.22.077 11.634.077h199.29c6.414 0 11.634 5.194 11.634 11.576v21.461c0 6.382-5.213 11.577-11.633 11.577zM11.634 6.78c-2.698 0-4.89 2.182-4.89 4.866v21.462c0 2.684 2.192 4.865 4.89 4.865h199.29c2.692 0 4.89-2.181 4.89-4.865V11.646c0-2.684-2.192-4.865-4.89-4.865H11.635z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M63.039 118.714a3.365 3.365 0 0 1-3.365-3.364V66.575a3.365 3.365 0 0 1 6.729 0v48.775c0 1.864-1.5 3.364-3.364 3.364zM95.538 118.714a3.365 3.365 0 0 1-3.365-3.364V66.575a3.365 3.365 0 0 1 6.729 0v48.775c0 1.864-1.5 3.364-3.364 3.364zM128.036 118.714a3.365 3.365 0 0 1-3.364-3.364V66.575a3.365 3.365 0 0 1 6.729 0v48.775a3.361 3.361 0 0 1-3.365 3.364zM160.535 118.714a3.365 3.365 0 0 1-3.364-3.364V66.575a3.365 3.365 0 0 1 6.729 0v48.775a3.361 3.361 0 0 1-3.365 3.364z"
}));

function SvgBucket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223,
    height: 147,
    viewBox: "0 0 223 147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucket);
export default __webpack_public_path__ + "static/media/bucket.95646750.svg";
export { ForwardRef as ReactComponent };